var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { Button, Icon } from "semantic-ui-react";
import { KeycloakContainer } from "../state/KeycloakContainer";
export function NotAllowed(props) {
    var logout = KeycloakContainer.useContainer().logout;
    return (React.createElement("div", __assign({}, props),
        React.createElement("h1", null, "Access is not allowed!"),
        React.createElement(Button, { color: "red", onClick: logout },
            React.createElement(Icon, { name: "log out" }),
            "Sign out")));
}
